import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { forEach, mapValues, values } from "lodash-es";

import { REWARD_ACTION_TYPE } from "./reward.action";
import { Reward, Rewards, RewardsPayload, RewardState, RewardStateFilterType } from "./reward.model";

const INITIAL_STATE: RewardState = {
	rewards: {},
};

export function rewardReducer(state = INITIAL_STATE, action: ActionWithPayload): RewardState {
	switch (action.type) {
		case REWARD_ACTION_TYPE.claimSuccess:
		case REWARD_ACTION_TYPE.forfeitSuccess:
		case REWARD_ACTION_TYPE.clear: {
			const payload = action.payload as RewardStateFilterType;

			if (!payload) {
				return INITIAL_STATE;
			}

			const rewards = {
				...state.rewards,
				[payload]: state.rewards[payload],
			};

			return updateState(state, { rewards });
		}
		case REWARD_ACTION_TYPE.getFail:
		case REWARD_ACTION_TYPE.getAllFail: {
			return INITIAL_STATE;
		}
		case REWARD_ACTION_TYPE.getSuccess: {
			const payload = action.payload as Reward;
			const { stateFilter, identifier } = payload;
			const rewards = mapValues(state.rewards, (rewardGroup) =>
				rewardGroup ? rewardGroup.filter((reward) => reward.identifier !== identifier) : []
			);

			rewards[stateFilter] = rewards[stateFilter] || [];
			(rewards[stateFilter] as Reward[]).push(payload);

			return updateState(state, { rewards });
		}
		case REWARD_ACTION_TYPE.getAllSuccess: {
			const payload = action.payload as RewardsPayload;
			// empty states are not returned from API, create empty arrays for them
			const emptyStates: Rewards = {};
			forEach(payload.stateFilters || values(RewardStateFilterType), (filter) => {
				if (!payload.rewards.hasOwnProperty(filter)) {
					emptyStates[filter] = [];
				}
			});

			return updateState(state, {
				rewards: Object.assign({}, state.rewards, payload.rewards, emptyStates),
			});
		}
		default:
			return state;
	}
}
